import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider } from '@ibk/shared-translation';
import { sharedUiTranslations } from '../../translations';
import { FileUploadBase } from './FileUploadBase';
export const FileUpload = props => {
    return (_jsx(TranslationProvider, { translations: sharedUiTranslations, defaultLanguage: 'pt-BR', children: _jsx(FileUploadBase, { ...props }) }));
};
